import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ModelSignal, model } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { StatusService, SystemStatus, DEFAULT_STATUS } from "./status.service";
import { NotificationsService } from "../../../../shared/_services/notifications.service";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-status",
    templateUrl: "./status.component.html",
    styleUrls: ["./status.component.scss"],
    standalone: false,
})
export class StatusComponent implements OnInit, OnDestroy {
    status: ModelSignal<SystemStatus> = model<SystemStatus>(DEFAULT_STATUS);
    loading = true;
    private ngUnsubscribe = new Subject<any>();

    constructor(
        private statusService: StatusService,
        private notificationService: NotificationsService,
    ) {}

    ngOnInit(): void {
        this.statusService
            .get()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (status) => {
                    this.status.set(status);
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                    this.notificationService.showError("Error", "Failed to load system status");
                },
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }

    formatDuration(seconds: number | undefined | null): string {
        if (!seconds) {
            return "N/A";
        }

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);

        if (hours > 0) {
            return `${hours}h ${minutes}m ${secs}s`;
        } else if (minutes > 0) {
            return `${minutes}m ${secs}s`;
        } else {
            return `${secs}s`;
        }
    }

    getTimeUntilRun(scheduledStartAtUtc: string | Date): string {
        const now = new Date();
        const scheduledTime = new Date(scheduledStartAtUtc);
        const diffMs = scheduledTime.getTime() - now.getTime();

        if (diffMs <= 0) {
            return "Starting soon...";
        }

        const totalSeconds = Math.floor(diffMs / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const parts: string[] = [];
        if (hours > 0) {
            parts.push(`${hours.toString().padStart(2, "0")}h`);
        }
        if (hours > 0 || minutes > 0) {
            parts.push(`${minutes.toString().padStart(2, "0")}m`);
        }
        parts.push(`${seconds.toString().padStart(2, "0")}s`);

        return parts.join(" ");
    }
}
